import React, {useEffect, useState} from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
const AutoForm = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);
    const [formValues, setFormValues] = useState({
        year: '',
        make: '',
        model: '',
        style: '',
        vin: '',
        glassType: '',
        damageDescription: '',
        name: '',
        email: '',
        phone: '',
        address: ''
    });

    const [errors, setErrors] = useState({}); // State to store validation errors
    useEffect(() => {
        if (formValues.vin.length === 17) {
            setFormValues(prev => ({
                ...prev,
                year: '',
                make: '',
                model: '',
                style: ''
            }));
        }
    }, [formValues.vin]);
    useEffect(() => {
        if (isSubmitting) {
            toast.loading("Waiting...", {id: "submit-toast"});
        } else {
            toast.dismiss("submit-toast");
        }
    }, [isSubmitting]);

    const handleChange = (e) => {
        const {name, value} = e.target;
        let updatedValues = {
            ...formValues,
            [name]: value
        };

        setFormValues(updatedValues);
        validateField(name, value);
    };

    const validateField = (fieldName, value) => {
        let error = '';
        switch (fieldName) {
            case 'year':
                if (value.length === 0) 
                    error = 'Year is required';
                else if (isNaN(value) || value.length !== 4) 
                    error = 'Invalid year';
                break;
            case 'make':
            case 'model':
            case 'style':
                if (value.length === 0) 
                    error = 'Field is required';
                break;
            case 'vin':
                if (value.length === 0) 
                    error = 'VIN is required';
                else if (value.length !== 17) 
                    error = 'Invalid VIN length';
                break;
            case 'glassType':
                if (value === '') 
                    error = 'Glass type is required';
                break;
            case 'damageDescription':
                if (value.length === 0) 
                    error = 'Description is required';
                break;
            case 'name':
                if (value.length === 0) 
                    error = 'Name is required';
                break;
            case 'phone':
                if (value.length === 0) 
                    error = 'Phone is required';
                else if (!/^\d{3}-\d{3}-\d{4}$/.test(value)) 
                    error = 'Invalid phone format (XXX-XXX-XXXX)';
                break;
            default:
                break;
        }
        setErrors((prevErrors) => ({
            ...prevErrors,
            [fieldName]: error
        }));
    };
    const resetForm = () => {
        setFormValues({
            year: '',
            make: '',
            model: '',
            style: '',
            vin: '',
            glassType: '',
            damageDescription: '',
            name: '',
            email: '',
            phone: '',
            address: ''
        });
        setErrors({});
        setCurrentStep(1);
    };
    const stepTitles = {
        1: "Tell us about your Vehicle",
        2: "What kind of glass is damaged?",
        3: "Describe the damage",
        4: "Enter your contact details"
      };
      
    const handleNextStep = () => {
        let isValid = true;
        switch (currentStep) {
            case 1:
                if (formValues.vin && formValues.vin.length === 17) {
                    setCurrentStep(currentStep + 1);
                    return;
                } else if (!formValues.year || !formValues.make || !formValues.model || !formValues.style) {
                    isValid = false;
                    validateField('year', formValues.year);
                    validateField('make', formValues.make);
                    validateField('model', formValues.model);
                    validateField('style', formValues.style);
                } else {
                    setCurrentStep(currentStep + 1);
                }
                break;
            case 2:
                if (formValues.glassType === '') {
                    isValid = false;
                    validateField('glassType', formValues.glassType);
                }
                break;
            case 3:
                if (formValues.damageDescription === '') {
                    isValid = false;
                    validateField('damageDescription', formValues.damageDescription);
                }
                break;
            default:
                break;
        }
        if (isValid) 
            setCurrentStep(currentStep + 1);
        };
    
    const handlePrevStep = () => {
        setCurrentStep(currentStep - 1);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formValues.name || !formValues.email || !formValues.phone || !formValues.address) {
            validateField('name', formValues.name);
            validateField('email', formValues.email);
            validateField('phone', formValues.phone);
            validateField('address', formValues.address);
            return;
        }
        setIsSubmitting(true);
        const inquiryData = {
            serviceType: 'automotive',
            dateReceived: new Date()
                .toISOString()
                .split('T')[0],
            name: formValues.name,
            year: formValues.year,
            make: formValues.make,
            model: formValues.model,
            style: formValues.style,
            vin: formValues.vin,
            status: 'New',
            contact: formValues.phone,
            email: formValues.email,
            address: formValues.address,
            files: '',
            notes: '',
            glassType: formValues.glassType,
            damageType: formValues.damageDescription
        };

        const jsonData = JSON.stringify(inquiryData);
        try { // eslint-disable-next-line
            const response = await axios.post(
                'https://script.google.com/macros/s/AKfycbzPiKp2JO01O-HbgWnJMq6u-SIFs3OT51CrckC4FN2em7azHnawAoEI6rDbss19Nv7o/exec',
                null,
                {
                    params: {
                        jsonData: jsonData
                    }
                }
            );
            toast('Form submitted successfully!');
            setIsSubmitting(false);
            resetForm();
        } catch (error) {
            toast('Submission failed. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div
            className="self-stretch flex flex-col justify-start items-start gap-9 h-full">
            <div
                className="self-stretch py-4 flex flex-col justify-center items-center gap-2">
              <h2>{stepTitles[currentStep]}</h2>

            </div>

            <form onSubmit={handleSubmit} className='flex flex-col gap-4 w-full flex-1'>

                {
                    currentStep === 1 && (
                        <Step1
                            formValues={formValues}
                            handleChange={handleChange}
                            handleNextStep={handleNextStep}
                            errors={errors}/>
                    )

                }
                {
                    currentStep === 2 && (
                        <Step2
                            formValues={formValues}
                            handleChange={handleChange}
                            handleNextStep={handleNextStep}
                            handlePrevStep={handlePrevStep}
                            errors={errors}/>
                    )
                }
                {
                    currentStep === 3 && (
                        <Step3
                            formValues={formValues}
                            handleChange={handleChange}
                            handleNextStep={handleNextStep}
                            handlePrevStep={handlePrevStep}
                            errors={errors}/>
                    )
                }
                {
                    currentStep === 4 && (
                        <Step4
                            formValues={formValues}
                            handleChange={handleChange}
                            handlePrevStep={handlePrevStep}
                            handleSubmit={handleSubmit}
                            errors={errors}/>
                    )
                }
                <div className="w-full flex justify-center mb-4">
                    <div className="flex gap-2">
                        {
                            [1, 2, 3, 4].map((step) => (
                                <div
                                    key={step}
                                    className={`w-4 h-4 rounded-full ${currentStep >= step
                                        ? 'bg-primary'
                                        : 'bg-accent'}`}/>
                            ))
                        }
                    </div>
                </div>
                <div className="flex justify-between mt-4">
    {currentStep > 1 && (
        <button
            type="button"
            onClick={handlePrevStep}
            className="px-6 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 text-gray-700 transition"
        >
            Back
        </button>
    )}

    {currentStep < 4 && (
        <button
            type="button"
            onClick={handleNextStep}
            className="ml-auto px-6 py-2 rounded-lg bg-primary hover:bg-accent text-white hover:text-primary transition"
        >
            Next
        </button>
    )}

    {currentStep === 4 && (
        <button
            type="submit"
            disabled={isSubmitting}
            className={`ml-auto px-6 py-2 rounded-lg transition ${
                isSubmitting
                    ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                    : "bg-primary hover:bg-accent text-white hover:text-primary"
            }`}
        >
            {isSubmitting ? "Submitting..." : "Submit"}
        </button>
    )}
</div>

            </form>
        </div>
    );
};

export default AutoForm;